import React from 'react';

interface IconCircleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: number;
  icon: React.ReactNode;
}

export const IconCircleButton: React.FC<IconCircleButtonProps> = ({
  size = 36,
  icon,
  className = '',
  ...props
}) => {
  const dimension = `${size}px`;
  return (
    <button
      type="button"
      {...props}
      className={`flex items-center justify-center rounded-full border border-white/10 bg-white/10 text-white/80 transition-colors hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/60 ${className}`}
      style={{ width: dimension, height: dimension }}
    >
      {icon}
    </button>
  );
};

